import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { locationMap, mobileMap } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFLink href="https://goo.gl/maps/WjoJskphdmyhmGmf6">
          <CFImage
            src={mobileMap}
            w="100%"
            alt="Cafe Salade de Fruits French Bistro Restaurant Map"
          />
        </CFLink>
      </MobileScreen>
      <DefaultScreen>
        <CFLink href="https://goo.gl/maps/WjoJskphdmyhmGmf6">
          <CFImage
            src={locationMap}
            w="100%"
            alt="Cafe Salade de Fruits French Bistro Restaurant Map"
          />
        </CFLink>
      </DefaultScreen>
    </CFView>
  )
}
